/**
 * buildMediaUnitIdLookup
 *
 * Builds a lookup from the snapshot-row id (`ClientOfferItem.id`) to the
 * unit's `mediaUnitId` — the id space `unitDecisions[].unitId` requires
 * (client-offer-decision-persistence). Shared by client-offer-page.tsx (SSO)
 * and public-offer-page.tsx (public link) — both consume a structurally
 * compatible `{id, mediaUnitId}[]` shape (`OfferSnapshotUnit[]` /
 * `ClientOfferViewUnit[]`). Rows whose `mediaUnitId` is not a positive
 * integer are omitted (unresolvable).
 */
export function buildMediaUnitIdLookup(
  units: { id: number; mediaUnitId: number }[],
): Map<string, number> {
  const lookup = new Map<string, number>();
  for (const unit of units) {
    if (Number.isInteger(unit.mediaUnitId) && unit.mediaUnitId > 0) {
      lookup.set(String(unit.id), unit.mediaUnitId);
    }
  }
  return lookup;
}
